export const loadFileFromUrl = (url: string, fileName: string) =>
  fetch(url).then(async (response) => {
    const contentType = response.headers.get('content-type');
    const blob = await response.blob();
    const file = new File([blob], fileName, { type: contentType! });
    return file;
  });
